export default __webpack_public_path__ + "static/media/Prof. Rajendra Pratap Gupta.35b5470a.jpg";